import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer/Footer';
import { SHNavbar } from '../../components/Tools/Navbar/Navbar';
import { Breadcrumb } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

const PageTemplate = ({ content }) => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Encoder Wheel Line Trackers');

	return (
		<>
			<Header plant="warren" />
			<main>
				<wrapper class="section-wrapper">
					<SHNavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Part / Skid Detect</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">{content}</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default PageTemplate;
